export const attractionTaxonomyStaticData = {
  taxonomy_tree: [
    {
      uuid: '18e7a878-acf8-d66d-3db4-197b04295c8e',
      name: 'Food & drink',
      startDate: '2022-10-26T14:05:58.401751Z',
      isCurrent: true,
      version: 2,
      parentUuid: '18e7a878-acf8-d66d-3db4-197b04295c8e',
      family: 'activities',
      slug: 'activities-food-drink',
      localizedName: 'Food & drink',
      children: [
        {
          uuid: '32bf868b-a866-5bc0-d91a-8f4f20b3d404',
          name: 'Workshops & classes',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
              '18e7a878-acf8-d66d-3db4-197b04295c8e#32bf868b-a866-5bc0-d91a-8f4f20b3d404',
          nameFullPath: 'Food & drink#Workshops & classes',
          family: 'activities',
          slug: 'activities-food-drink-workshops-classes',
          localizedName: 'Workshops & classes',
        },
        {
          uuid: 'a2543e93-3a5f-4ec5-6d7e-718b7b357af2',
          name: 'Tickets & passes',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
              '18e7a878-acf8-d66d-3db4-197b04295c8e#a2543e93-3a5f-4ec5-6d7e-718b7b357af2',
          nameFullPath: 'Food & drink#Tickets & passes',
          family: 'activities',
          slug: 'activities-food-drink-tickets-passes',
          localizedName: 'Tickets & passes',
        },
        {
          uuid: '9fc163b8-0ee9-9959-9320-c3a94326cd97',
          name: 'Food & drink tours',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
              '18e7a878-acf8-d66d-3db4-197b04295c8e#9fc163b8-0ee9-9959-9320-c3a94326cd97',
          nameFullPath: 'Food & drink#Food & drink tours',
          family: 'activities',
          slug: 'activities-food-drink-food-drink-tours',
          localizedName: 'Food & drink tours',
        },
        {
          uuid: 'fa2af9e8-9eeb-264e-7983-7635cc54521d',
          name: 'Restaurants & bars',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
              '18e7a878-acf8-d66d-3db4-197b04295c8e#fa2af9e8-9eeb-264e-7983-7635cc54521d',
          nameFullPath: 'Food & drink#Restaurants & bars',
          family: 'activities',
          slug: 'activities-food-drink-restaurants-bars',
          localizedName: 'Restaurants & bars',
        },
      ],
    },
    {
      uuid: '4d9d4480-ed7d-51b1-6bd8-c7f11f964bfa',
      name: 'Action & entertainment',
      startDate: '2022-10-26T14:05:58.401751Z',
      isCurrent: true,
      version: 2,
      parentUuid: '4d9d4480-ed7d-51b1-6bd8-c7f11f964bfa',
      family: 'activities',
      slug: 'activities-action-entertainment',
      localizedName: 'Action & entertainment',
      children: [
        {
          uuid: '7177fdad-1dc5-6439-d0b0-308460837a2c',
          name: 'Multi-adventure & games',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
              '4d9d4480-ed7d-51b1-6bd8-c7f11f964bfa#7177fdad-1dc5-6439-d0b0-308460837a2c',
          nameFullPath: 'Action & entertainment#Multi-adventure & games',
          family: 'activities',
          slug: 'activities-action-entertainment-multi-adventure-games',
          localizedName: 'Multi-adventure & games',
        },
        {
          uuid: '0163f78a-e167-4c9c-4ad5-f6b0d6f3a065',
          name: 'Rentals & rides',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
              '4d9d4480-ed7d-51b1-6bd8-c7f11f964bfa#0163f78a-e167-4c9c-4ad5-f6b0d6f3a065',
          nameFullPath: 'Action & entertainment#Rentals & rides',
          family: 'activities',
          slug: 'activities-action-entertainment-rentals-rides',
          localizedName: 'Rentals & rides',
        },
        {
          uuid: '61e16f33-acbb-f959-2dd0-04a43df63703',
          name: 'Tickets & passes',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
              '4d9d4480-ed7d-51b1-6bd8-c7f11f964bfa#61e16f33-acbb-f959-2dd0-04a43df63703',
          nameFullPath: 'Action & entertainment#Tickets & passes',
          family: 'activities',
          slug: 'activities-action-entertainment-tickets-passes',
          localizedName: 'Tickets & passes',
        },
        {
          uuid: 'b1b434a1-b228-03fc-d5bc-1095a72804b7',
          name: 'Water',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
              '4d9d4480-ed7d-51b1-6bd8-c7f11f964bfa#b1b434a1-b228-03fc-d5bc-1095a72804b7',
          nameFullPath: 'Action & entertainment#Water',
          family: 'activities',
          slug: 'activities-action-entertainment-water',
          localizedName: 'Water',
        },
        {
          uuid: '54e7b62c-ab2c-cf77-dd70-7d7eccdeb0ca',
          name: 'Land',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
              '4d9d4480-ed7d-51b1-6bd8-c7f11f964bfa#54e7b62c-ab2c-cf77-dd70-7d7eccdeb0ca',
          nameFullPath: 'Action & entertainment#Land',
          family: 'activities',
          slug: 'activities-action-entertainment-land',
          localizedName: 'Land',
        },
        {
          uuid: 'e1cf9197-8f6b-bff8-7c8a-3b260e4a309f',
          name: 'Shopping',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
              '4d9d4480-ed7d-51b1-6bd8-c7f11f964bfa#e1cf9197-8f6b-bff8-7c8a-3b260e4a309f',
          nameFullPath: 'Action & entertainment#Shopping',
          family: 'activities',
          slug: 'activities-action-entertainment-shopping',
          localizedName: 'Shopping',
        },
        {
          uuid: '4117c4f4-32ef-db9b-eb82-2718e3f24b6c',
          name: 'Air',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
              '4d9d4480-ed7d-51b1-6bd8-c7f11f964bfa#4117c4f4-32ef-db9b-eb82-2718e3f24b6c',
          nameFullPath: 'Action & entertainment#Air',
          family: 'activities',
          slug: 'activities-action-entertainment-air',
          localizedName: 'Air',
        },
        {
          uuid: '5615286d-3eb9-c0f4-b01f-a1468ebc60a7',
          name: 'Sport lessons',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
              '4d9d4480-ed7d-51b1-6bd8-c7f11f964bfa#5615286d-3eb9-c0f4-b01f-a1468ebc60a7',
          nameFullPath: 'Action & entertainment#Sport lessons',
          family: 'activities',
          slug: 'activities-action-entertainment-sport-lessons',
          localizedName: 'Sport lessons',
        },
        {
          uuid: '6e635c52-6db4-ab62-11ca-6c9cea604d01',
          name: 'Shows & events',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
              '4d9d4480-ed7d-51b1-6bd8-c7f11f964bfa#6e635c52-6db4-ab62-11ca-6c9cea604d01',
          nameFullPath: 'Action & entertainment#Shows & events',
          family: 'activities',
          slug: 'activities-action-entertainment-shows-events',
          localizedName: 'Shows & events',
        },
      ],
    },
    {
      uuid: '47b35ad2-500d-843f-aa5e-788056844a33',
      name: 'Nature & outdoors',
      startDate: '2022-10-26T14:05:58.401751Z',
      isCurrent: true,
      version: 2,
      parentUuid: '47b35ad2-500d-843f-aa5e-788056844a33',
      family: 'activities',
      slug: 'activities-nature-outdoors',
      localizedName: 'Nature & outdoors',
      children: [
        {
          uuid: 'acfca8fe-3aa0-e078-16a8-d9d72022cd43',
          name: 'Tickets & passes',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
            '47b35ad2-500d-843f-aa5e-788056844a33#acfca8fe-3aa0-e078-16a8-d9d72022cd43',
          nameFullPath: 'Nature & outdoors#Tickets & passes',
          family: 'activities',
          slug: 'activities-nature-outdoors-tickets-passes',
          localizedName: 'Tickets & passes',
        },
        {
          uuid: 'c4d8554d-4a7e-ade8-d3d7-5ddbf0d298cc',
          name: 'Water activities',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
            '47b35ad2-500d-843f-aa5e-788056844a33#c4d8554d-4a7e-ade8-d3d7-5ddbf0d298cc',
          nameFullPath: 'Nature & outdoors#Water activities',
          family: 'activities',
          slug: 'activities-nature-outdoors-water-activities',
          localizedName: 'Water activities',
        },
        {
          uuid: 'b7c09f3e-b8cb-a9df-8218-ae6f0f7c85b6',
          name: 'Zoos & aquariums',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
            '47b35ad2-500d-843f-aa5e-788056844a33#b7c09f3e-b8cb-a9df-8218-ae6f0f7c85b6',
          nameFullPath: 'Nature & outdoors#Zoos & aquariums',
          family: 'activities',
          slug: 'activities-nature-outdoors-zoos-aquariums',
          localizedName: 'Zoos & aquariums',
        },
        {
          uuid: '68310fe1-1a50-4a2d-6ea1-7e6177725f79',
          name: 'Wildlife & nature observation',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
            '47b35ad2-500d-843f-aa5e-788056844a33#68310fe1-1a50-4a2d-6ea1-7e6177725f79',
          nameFullPath: 'Nature & outdoors#Wildlife & nature observation',
          family: 'activities',
          slug: 'activities-nature-outdoors-wildlife-nature-observation',
          localizedName: 'Wildlife & nature observation',
        },
        {
          uuid: '461140c7-6141-4fca-356d-ff1582121ba6',
          name: 'Land activities',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
            '47b35ad2-500d-843f-aa5e-788056844a33#461140c7-6141-4fca-356d-ff1582121ba6',
          nameFullPath: 'Nature & outdoors#Land activities',
          family: 'activities',
          slug: 'activities-nature-outdoors-land-activities',
          localizedName: 'Land activities',
        },
        {
          uuid: '7c3f64ea-c227-6145-3755-1f0133a3b414',
          name: 'Air activities',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
            '47b35ad2-500d-843f-aa5e-788056844a33#7c3f64ea-c227-6145-3755-1f0133a3b414',
          nameFullPath: 'Nature & outdoors#Air activities',
          family: 'activities',
          slug: 'activities-nature-outdoors-air-activities',
          localizedName: 'Air activities',
        },
      ],
    },
    {
      uuid: 'aaf05b8d-e9a7-d912-9c3e-3cc56bbcb3b0',
      name: 'Transportation',
      startDate: '2022-10-26T14:05:58.401751Z',
      isCurrent: true,
      version: 2,
      parentUuid: 'aaf05b8d-e9a7-d912-9c3e-3cc56bbcb3b0',
      family: 'activities',
      slug: 'activities-transportation',
      localizedName: 'Transportation',
      children: [
        {
          uuid: 'ffc6b9c9-e9ca-5209-7817-ddf47d659440',
          name: 'Rentals & rides',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
              'aaf05b8d-e9a7-d912-9c3e-3cc56bbcb3b0#ffc6b9c9-e9ca-5209-7817-ddf47d659440',
          nameFullPath: 'Transportation#Rentals & rides',
          family: 'activities',
          slug: 'activities-transportation-rentals-rides',
          localizedName: 'Rentals & rides',
        },
        {
          uuid: '90070e68-756b-2230-0039-4c98306f136c',
          name: 'Transfers',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
              'aaf05b8d-e9a7-d912-9c3e-3cc56bbcb3b0#90070e68-756b-2230-0039-4c98306f136c',
          nameFullPath: 'Transportation#Transfers',
          family: 'activities',
          slug: 'activities-transportation-transfers',
          localizedName: 'Transfers',
        },
      ],
    },
    {
      uuid: '6a334ebe-1fee-37f9-80b8-bfc38cd62fa6',
      name: 'Culture',
      startDate: '2022-10-26T14:05:58.401751Z',
      isCurrent: true,
      version: 2,
      parentUuid: '6a334ebe-1fee-37f9-80b8-bfc38cd62fa6',
      family: 'activities',
      slug: 'activities-culture',
      localizedName: 'Culture',
      children: [
        {
          uuid: '0e8137e5-4712-d411-4a7b-4be80522ad11',
          name: 'Art & culture tours',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
            '6a334ebe-1fee-37f9-80b8-bfc38cd62fa6#0e8137e5-4712-d411-4a7b-4be80522ad11',
          nameFullPath: 'Culture#Art & culture tours',
          family: 'activities',
          slug: 'activities-culture-art-culture-tours',
          localizedName: 'Art & culture tours',
        },
        {
          uuid: '2ba0dbb3-7437-8210-8540-6e3ffd4202a1',
          name: 'Tickets & passes',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
            '6a334ebe-1fee-37f9-80b8-bfc38cd62fa6#2ba0dbb3-7437-8210-8540-6e3ffd4202a1',
          nameFullPath: 'Culture#Tickets & passes',
          family: 'activities',
          slug: 'activities-culture-tickets-passes',
          localizedName: 'Tickets & passes',
        },
        {
          uuid: '7d19b2f2-241a-00d6-3884-cdaae798c95c',
          name: 'Shows & events',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
            '6a334ebe-1fee-37f9-80b8-bfc38cd62fa6#7d19b2f2-241a-00d6-3884-cdaae798c95c',
          nameFullPath: 'Culture#Shows & events',
          family: 'activities',
          slug: 'activities-culture-shows-events',
          localizedName: 'Shows & events',
        },
      ],
    },
    {
      uuid: '8abf5577-24c8-29c9-d1a5-ad6f49b9fba0',
      name: 'Health & wellness',
      startDate: '2022-10-26T14:05:58.401751Z',
      isCurrent: true,
      version: 2,
      parentUuid: '8abf5577-24c8-29c9-d1a5-ad6f49b9fba0',
      family: 'activities',
      slug: 'activities-health-wellness',
      localizedName: 'Health & wellness',
      children: [
        {
          uuid: 'e3bb498d-3e1d-8de1-a14d-1876375beada',
          name: 'Alternative medicine',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
            '8abf5577-24c8-29c9-d1a5-ad6f49b9fba0#e3bb498d-3e1d-8de1-a14d-1876375beada',
          nameFullPath: 'Health & wellness#Alternative medicine',
          family: 'activities',
          slug: 'activities-health-wellness-alternative-medicine',
          localizedName: 'Alternative medicine',
        },
        {
          uuid: '9b14e611-d399-ac9e-c579-f7714fb318bb',
          name: 'Spas',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
            '8abf5577-24c8-29c9-d1a5-ad6f49b9fba0#9b14e611-d399-ac9e-c579-f7714fb318bb',
          nameFullPath: 'Health & wellness#Spas',
          family: 'activities',
          slug: 'activities-health-wellness-spas',
          localizedName: 'Spas',
        },
        {
          uuid: '52f8fdb3-b74a-56de-9821-d12c0f8c9e37',
          name: 'Relaxation',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
            '8abf5577-24c8-29c9-d1a5-ad6f49b9fba0#52f8fdb3-b74a-56de-9821-d12c0f8c9e37',
          nameFullPath: 'Health & wellness#Relaxation',
          family: 'activities',
          slug: 'activities-health-wellness-relaxation',
          localizedName: 'Relaxation',
        },
        {
          uuid: 'ae34bf13-c916-d533-d4c2-a6be52411e87',
          name: 'Retreats',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
            '8abf5577-24c8-29c9-d1a5-ad6f49b9fba0#ae34bf13-c916-d533-d4c2-a6be52411e87',
          nameFullPath: 'Health & wellness#Retreats',
          family: 'activities',
          slug: 'activities-health-wellness-retreats',
          localizedName: 'Retreats',
        },
        {
          uuid: '0ea5cfca-9af8-ae02-2b9d-d5230dfded07',
          name: 'Beauty treatments',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
            '8abf5577-24c8-29c9-d1a5-ad6f49b9fba0#0ea5cfca-9af8-ae02-2b9d-d5230dfded07',
          nameFullPath: 'Health & wellness#Beauty treatments',
          family: 'activities',
          slug: 'activities-health-wellness-beauty-treatments',
          localizedName: 'Beauty treatments',
        },
      ],
    },
    {
      uuid: 'd6db031f-d64f-ceb4-247e-cf5e812a2bab',
      name: 'Workshops & classes',
      startDate: '2022-10-26T14:05:58.401751Z',
      isCurrent: true,
      version: 2,
      parentUuid: 'd6db031f-d64f-ceb4-247e-cf5e812a2bab',
      family: 'activities',
      slug: 'activities-workshops-classes',
      localizedName: 'Workshops & classes',
      children: [
        {
          uuid: 'e5d42875-a869-fb7d-b87c-224bef4e239b',
          name: 'Cultural immersion',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
              'd6db031f-d64f-ceb4-247e-cf5e812a2bab#e5d42875-a869-fb7d-b87c-224bef4e239b',
          nameFullPath: 'Workshops & classes#Cultural immersion',
          family: 'activities',
          slug: 'activities-workshops-classes-cultural-immersion',
          localizedName: 'Cultural immersion',
        },
        {
          uuid: '1d4e2461-f49d-5c2b-da6c-4ff483307ee3',
          name: 'Arts & crafts',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
              'd6db031f-d64f-ceb4-247e-cf5e812a2bab#1d4e2461-f49d-5c2b-da6c-4ff483307ee3',
          nameFullPath: 'Workshops & classes#Arts & crafts',
          family: 'activities',
          slug: 'activities-workshops-classes-arts-crafts',
          localizedName: 'Art & crafts',
        },
        {
          uuid: '9d95bb5a-cf84-22f6-8646-898fdeb56bf9',
          name: 'Food & drink',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
              'd6db031f-d64f-ceb4-247e-cf5e812a2bab#9d95bb5a-cf84-22f6-8646-898fdeb56bf9',
          nameFullPath: 'Workshops & classes#Food & drink',
          family: 'activities',
          slug: 'activities-workshops-classes-food-drink',
          localizedName: 'Food & drink',
        },
        {
          uuid: '5d6e6213-9b78-527e-cfe9-027a68f287c8',
          name: 'Sport lessons',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
              'd6db031f-d64f-ceb4-247e-cf5e812a2bab#5d6e6213-9b78-527e-cfe9-027a68f287c8',
          nameFullPath: 'Workshops & classes#Sport lessons',
          family: 'activities',
          slug: 'activities-workshops-classes-sport-lessons',
          localizedName: 'Sport lessons',
        },
        {
          uuid: '8bd76f27-d984-0564-5dbd-6a2c1a78ee2b',
          name: 'Music & dance',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
              'd6db031f-d64f-ceb4-247e-cf5e812a2bab#8bd76f27-d984-0564-5dbd-6a2c1a78ee2b',
          nameFullPath: 'Workshops & classes#Music & dance',
          family: 'activities',
          slug: 'activities-workshops-classes-music-dance',
          localizedName: 'Music & dance',
        },
      ],
    },
    {
      uuid: '8385073f-4317-0889-6bc4-d52fe0337577',
      name: 'Tours by theme',
      startDate: '2022-10-26T14:05:58.401751Z',
      isCurrent: true,
      version: 2,
      parentUuid: '8385073f-4317-0889-6bc4-d52fe0337577',
      family: 'activities',
      slug: 'activities-tours-by-theme',
      localizedName: 'Tours by theme',
      children: [
        {
          uuid: '7537eb05-3848-44ae-6d67-2bd24aa194b7',
          name: 'Museum & exhibition tours',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
            '8385073f-4317-0889-6bc4-d52fe0337577#7537eb05-3848-44ae-6d67-2bd24aa194b7',
          nameFullPath: 'Tours by theme#Museum & exhibition tours',
          family: 'activities',
          slug: 'activities-tours-by-theme-museum-exhibition-tours',
          localizedName: 'Museum & exhibition tours',
        },
        {
          uuid: '66f4e2d9-c7e2-510e-e15a-71fa3507f6e3',
          name: 'Sport tours',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
            '8385073f-4317-0889-6bc4-d52fe0337577#66f4e2d9-c7e2-510e-e15a-71fa3507f6e3',
          nameFullPath: 'Tours by theme#Sport tours',
          family: 'activities',
          slug: 'activities-tours-by-theme-sport-tours',
          localizedName: 'Sport tours',
        },
        {
          uuid: '6d6e5dea-cad7-3315-1269-b40d4ea7bf9f',
          name: 'Historical heritage tours',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
            '8385073f-4317-0889-6bc4-d52fe0337577#6d6e5dea-cad7-3315-1269-b40d4ea7bf9f',
          nameFullPath: 'Tours by theme#Historical heritage tours',
          family: 'activities',
          slug: 'activities-tours-by-theme-historical-heritage-tours',
          localizedName: 'Historical heritage tours',
        },
        {
          uuid: '35fd68ca-219b-8918-98ab-35bbde3953b7',
          name: 'Night tours',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
            '8385073f-4317-0889-6bc4-d52fe0337577#35fd68ca-219b-8918-98ab-35bbde3953b7',
          nameFullPath: 'Tours by theme#Night tours',
          family: 'activities',
          slug: 'activities-tours-by-theme-night-tours',
          localizedName: 'Night tours',
        },
        {
          uuid: '989ef9f5-3057-60c9-c92d-7ac037941c32',
          name: 'Shopping tours',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
            '8385073f-4317-0889-6bc4-d52fe0337577#989ef9f5-3057-60c9-c92d-7ac037941c32',
          nameFullPath: 'Tours by theme#Shopping tours',
          family: 'activities',
          slug: 'activities-tours-by-theme-shopping-tours',
          localizedName: 'Shopping tours',
        },
        {
          uuid: '466ae74f-1846-8bd5-b237-46376cdd114d',
          name: 'Discovery tours',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
            '8385073f-4317-0889-6bc4-d52fe0337577#466ae74f-1846-8bd5-b237-46376cdd114d',
          nameFullPath: 'Tours by theme#Discovery tours',
          family: 'activities',
          slug: 'activities-tours-by-theme-discovery-tours',
          localizedName: 'Discovery tours',
        },
        {
          uuid: 'ceb97f22-d722-1581-c5c6-73fc8684bcf5',
          name: 'Luxury tours',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
            '8385073f-4317-0889-6bc4-d52fe0337577#ceb97f22-d722-1581-c5c6-73fc8684bcf5',
          nameFullPath: 'Tours by theme#Luxury tours',
          family: 'activities',
          slug: 'activities-tours-by-theme-luxury-tours',
          localizedName: 'Luxury tours',
        },
        {
          uuid: '6af0be4c-998b-240e-0960-14ccba494134',
          name: 'Food & drink tours',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
            '8385073f-4317-0889-6bc4-d52fe0337577#6af0be4c-998b-240e-0960-14ccba494134',
          nameFullPath: 'Tours by theme#Food & drink tours',
          family: 'activities',
          slug: 'activities-tours-by-theme-food-drink-tours',
          localizedName: 'Food & drink tours',
        },
        {
          uuid: '0169f5f6-29a0-7a60-6a33-8fa5e93bdd18',
          name: 'Virtual tours',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
            '8385073f-4317-0889-6bc4-d52fe0337577#0169f5f6-29a0-7a60-6a33-8fa5e93bdd18',
          nameFullPath: 'Tours by theme#Virtual tours',
          family: 'activities',
          slug: 'activities-tours-by-theme-virtual-tours',
          localizedName: 'Virtual tours',
        },
        {
          uuid: 'ef39d2ce-fcf0-b342-5302-89c3fccb2a45',
          name: 'Special tours',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
            '8385073f-4317-0889-6bc4-d52fe0337577#ef39d2ce-fcf0-b342-5302-89c3fccb2a45',
          nameFullPath: 'Tours by theme#Special tours',
          family: 'activities',
          slug: 'activities-tours-by-theme-special-tours',
          localizedName: 'Special tours',
        },
        {
          uuid: '6d4099a1-bd93-d6db-2b92-f7dec97341f1',
          name: 'Art & culture tours',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
            '8385073f-4317-0889-6bc4-d52fe0337577#6d4099a1-bd93-d6db-2b92-f7dec97341f1',
          nameFullPath: 'Tours by theme#Art & culture tours',
          family: 'activities',
          slug: 'activities-tours-by-theme-art-culture-tours',
          localizedName: 'Art & culture tours',
        },
        {
          uuid: '8410ea17-9ac4-3ca8-9fd1-f0197af4d106',
          name: 'Walking tours',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
            '8385073f-4317-0889-6bc4-d52fe0337577#8410ea17-9ac4-3ca8-9fd1-f0197af4d106',
          nameFullPath: 'Tours by theme#Walking tours',
          family: 'activities',
          slug: 'activities-tours-by-theme-walking-tours',
          localizedName: 'Walking tours',
        },
        {
          uuid: '65e73b47-fc6e-af79-f4ae-d384fc027260',
          name: 'Self-guided tours',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
            '8385073f-4317-0889-6bc4-d52fe0337577#65e73b47-fc6e-af79-f4ae-d384fc027260',
          nameFullPath: 'Tours by theme#Self-guided tours',
          family: 'activities',
          slug: 'activities-tours-by-theme-self-guided-tours',
          localizedName: 'Self-guided tours',
        },
        {
          uuid: '50022ab0-9a9f-7e8e-d8cf-0f665433aeb4',
          name: 'Nature & wildlife tours',
          startDate: '2022-10-26T14:05:58.401751Z',
          isCurrent: true,
          version: 2,
          parentUuid:
            '8385073f-4317-0889-6bc4-d52fe0337577#50022ab0-9a9f-7e8e-d8cf-0f665433aeb4',
          nameFullPath: 'Tours by theme#Nature & wildlife tours',
          family: 'activities',
          slug: 'activities-tours-by-theme-nature-wildlife-tours',
          localizedName: 'Nature & wildlife tours',
        },
      ],
    },
    {
      uuid: '41a2aefb-2282-40ac-8b33-cdea80a9e358',
      name: 'No Category',
      startDate: '2022-03-22T19:17:56.534158Z',
      isCurrent: true,
      version: 1,
      parentUuid: '41a2aefb-2282-40ac-8b33-cdea80a9e358',
      nameFullPath: 'No Category',
      family: 'activities',
      slug: 'activities-no-category',
      localizedName: 'No Category',
    },
  ],
  translations: {
    'activities-health-wellness-spas': 'Spas',
    'activities-action-entertainment-shows-events': 'Shows & events',
    'activities-nature-outdoors-zoos-aquariums': 'Zoos & aquariums',
    'activities-food-drink': 'Food & drink',
    'activities-action-entertainment-shopping': 'Shopping',
    'activities-nature-outdoors-tickets-passes': 'Tickets & passes',
    'activities-action-entertainment-rentals-rides': 'Rentals & rides',
    'activities-transportation': 'Transportation',
    'activities-culture-shows-events': 'Shows & events',
    'activities-nature-outdoors': 'Nature & outdoors',
    'activities-tours-by-theme-shopping-tours': 'Shopping tours',
    'activities-workshops-classes-sport-lessons': 'Sport lessons',
    'activities-action-entertainment-tickets-passes': 'Tickets & passes',
    'activities-workshops-classes-music-dance': 'Music & dance',
    'activities-food-drink-workshops-classes': 'Workshops & classes',
    'activities-health-wellness-relaxation': 'Relaxation',
    'activities-tours-by-theme-food-drink-tours': 'Food & drink tours',
    'activities-workshops-classes': 'Workshops & classes',
    'activities-health-wellness-beauty-treatments': 'Beauty treatments',
    'activities-action-entertainment-water': 'Water',
    'activities-workshops-classes-arts-crafts': 'Art & crafts',
    'activities-tours-by-theme': 'Tours by theme',
    'activities-action-entertainment-land': 'Land',
    'activities-tours-by-theme-sport-tours': 'Sport tours',
    'activities-culture': 'Culture',
    'activities-tours-by-theme-walking-tours': 'Walking tours',
    'activities-health-wellness-alternative-medicine': 'Alternative medicine',
    'activities-tours-by-theme-art-culture-tours': 'Art & culture tours',
    'activities-workshops-classes-cultural-immersion': 'Cultural immersion',
    'activities-health-wellness': 'Health & wellness',
    'activities-nature-outdoors-air-activities': 'Air activities',
    'activities-tours-by-theme-luxury-tours': 'Luxury tours',
    'activities-tours-by-theme-historical-heritage-tours':
      'Historical heritage tours',
    'activities-culture-art-culture-tours': 'Art & culture tours',
    'activities-action-entertainment-air': 'Air',
    'activities-tours-by-theme-nature-wildlife-tours':
      'Nature & wildlife tours',
    'activities-tours-by-theme-discovery-tours': 'Discovery tours',
    'activities-nature-outdoors-wildlife-nature-observation':
      'Wildlife & nature observation',
    'activities-action-entertainment': 'Action & entertainment',
    'activities-tours-by-theme-museum-exhibition-tours':
      'Museum & exhibition tours',
    'activities-workshops-classes-food-drink': 'Food & drink',
    'activities-tours-by-theme-virtual-tours': 'Virtual tours',
    'activities-tours-by-theme-special-tours': 'Special tours',
    'activities-nature-outdoors-land-activities': 'Land activities',
    'activities-transportation-rentals-rides': 'Rentals & rides',
    'activities-nature-outdoors-water-activities': 'Water activities',
    'activities-food-drink-restaurants-bars': 'Restaurants & bars',
    'activities-food-drink-food-drink-tours': 'Food & drink tours',
    'activities-no-category': 'No Category',
    'activities-health-wellness-retreats': 'Retreats',
    'activities-action-entertainment-sport-lessons': 'Sport lessons',
    'activities-tours-by-theme-self-guided-tours': 'Self-guided tours',
    'activities-action-entertainment-multi-adventure-games':
      'Multi-adventure & games',
    'activities-food-drink-tickets-passes': 'Tickets & passes',
    'activities-tours-by-theme-night-tours': 'Night tours',
    'activities-culture-tickets-passes': 'Tickets & passes',
    'activities-transportation-transfers': 'Transfers',
  },
};
